import { useHaptics } from '@/hooks/use-haptics';
import { Button } from '@mantine/core';
import { IconProps } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { ComponentProps, createElement, FunctionComponent } from 'react';
import styles from './styles.module.css';

type NavItemProps = ComponentProps<typeof Link> & {
	label: string;
	icon: FunctionComponent<IconProps>;
};

export const HeaderNavItem = ({ label, icon, ...props }: NavItemProps) => {
	const onClick = useHaptics(props);

	return (
		<Link {...props} onClick={onClick} className={styles.link}>
			<Button
				px="sm"
				variant="light"
				classNames={{ label: styles.label }}
				leftSection={createElement(icon, { className: styles.icon })}
			>
				{label}
			</Button>
		</Link>
	);
};
